/**
 * Extract variable placeholders from a prompt template.
 *
 * Matches the backend substitution pattern in
 * backend/src/services/llmService.js:89-95 (/\{(\w+)\}/g).
 * Keep the regex in sync with that file if the substitution rules change.
 *
 * @param {string} text - Any prompt text. Passing several prompts concatenated
 *                        with a separator is fine — the matcher is stateless.
 * @returns {string[]} Sorted, deduplicated variable names (without braces).
 */
export function extractVariables(text) {
  if (!text || typeof text !== 'string') return [];

  const pattern = /\{(\w+)\}/g;
  const seen = new Set();
  let match;
  while ((match = pattern.exec(text)) !== null) {
    seen.add(match[1]);
  }

  return [...seen].sort();
}
